/**
 * Production Management Utility Functions
 */

// Calculate UPM (Units Per Minute)
export const calculateUPM = (actualQuantity, unitsPerCase, startTime, endTime) => {
  if (!actualQuantity || !startTime || !endTime || !unitsPerCase) return null;
  
  const [startHour, startMin] = startTime.split(':').map(Number);
  const [endHour, endMin] = endTime.split(':').map(Number);
  
  const totalMinutes = (endHour * 60 + endMin) - (startHour * 60 + startMin);
  
  if (totalMinutes <= 0) return null;
  
  const totalUnits = actualQuantity * unitsPerCase;
  return (totalUnits / totalMinutes).toFixed(2);
};

// Calculate Uptime UPM (excluding downtime)
export const calculateUptimeUPM = (actualQuantity, unitsPerCase, startTime, endTime, downtimeMinutes) => {
  if (!actualQuantity || !startTime || !endTime || !unitsPerCase) return null;
  
  const [startHour, startMin] = startTime.split(':').map(Number);
  const [endHour, endMin] = endTime.split(':').map(Number);
  
  const totalMinutes = (endHour * 60 + endMin) - (startHour * 60 + startMin);
  const productiveMinutes = totalMinutes - (downtimeMinutes || 0);
  
  if (productiveMinutes <= 0) return null;
  
  const totalUnits = actualQuantity * unitsPerCase;
  return (totalUnits / productiveMinutes).toFixed(2);
};

// Get yield color based on item type and percentage
export const getYieldColor = (yieldPct, itemType) => {
  if (itemType === 'food') {
    if (yieldPct > 97.5) return 'green';
    if (yieldPct >= 90) return 'orange';
    return 'red';
  } else if (itemType === 'packaging') {
    if (yieldPct > 99) return 'green';
    if (yieldPct >= 97) return 'orange';
    return 'red';
  }
  return 'gray';
};

// Check if work order has any red yields
export const hasRedYields = (bomUsage) => {
  return bomUsage.some(item => {
    const color = getYieldColor(item.yield_pct, item.item_type);
    return color === 'red';
  });
};

// Format yield percentage to 2 decimal places
export const formatYield = (yieldPct) => {
  return Number(yieldPct).toFixed(2);
};

// Aggregate lot quantities
export const aggregateLotQuantities = (lots) => {
  const totalAllocated = lots.reduce((sum, lot) => sum + (lot.allocated_qty || 0), 0);
  const totalActual = lots.reduce((sum, lot) => sum + (lot.actual_qty || 0), 0);
  return { totalAllocated, totalActual };
};
